<template>
  <div class="az-form-content" style="padding-bottom: 75px">
    <v-btn v-if="ehFornecedor && possuiPermissaoRecurso && !prazoEncerrado" class="mx-0" color="primary" @click="exibirPainelInserirRecurso = true">Adicionar</v-btn>
    <v-tooltip top v-if="ehFornecedor && (!possuiPermissaoRecurso || prazoEncerrado)">
      <v-btn slot="activator" disabled class="mx-0" color="primary" @click="exibirPainelInserirRecurso = true">Adicionar</v-btn>
      <span v-if="!possuiPermissaoRecurso && !prazoEncerrado">Você não possui permissão para criar recurso em nenhum lote deste processo.</span>
      <span v-if="prazoEncerrado">O prazo de 3 dias úteis para envios foi encerrado <br> conforme <strong>LEI Nº 14.133, DE 1º DE ABRIL DE 2021</strong></span>
    </v-tooltip>
    <div v-if="recursos.length > 0 || contrarrazoes.length > 0">
    <v-flex xs12 sm12 d-flex>
      <span class="az-subtitle primary--text">Recursos</span>
    </v-flex>
    <v-flex xs12 sm12 d-flex>
      <credenciamento-recurso-contrarrazao-tabela id="tabela-recursos"
                                :recursosContrarrazoes="recursos"
                                :contrarrazoes="contrarrazoes"
                                :ehFornecedor="ehFornecedor"
                                :tipo="tipoRecursoContrarrazao.RECURSO"
                                :prazoEncerrado="prazoEncerrado"
                                @abrirVisualizacao="abrirModalVisualizar(tipoRecursoContrarrazao.RECURSO, ...arguments)"
                                @criarResposta="abrirModalCriarResposta(tipoRecursoContrarrazao.RECURSO, ...arguments)"
                                @criarContrarrazao="abrirModalCriarContrarrazao"/>
    </v-flex>
    <v-flex xs12 sm12 d-flex>
      <span class="az-subtitle primary--text">Contrarrazões</span>
    </v-flex>
    <v-flex xs12 sm12 d-flex>
      <credenciamento-recurso-contrarrazao-tabela id="tabela-contrarrazoes"
                                :recursosContrarrazoes="contrarrazoes"
                                :ehFornecedor="ehFornecedor"
                                :tipo="tipoRecursoContrarrazao.CONTRARRAZAO"
                                @abrirVisualizacao="abrirModalVisualizar(tipoRecursoContrarrazao.CONTRARRAZAO, ...arguments)"
                                @criarResposta="abrirModalCriarResposta(tipoRecursoContrarrazao.CONTRARRAZAO, ...arguments)"/>
    </v-flex>
    </div>
    <div v-else class="sem-conteudo">
      <span class="mx-2">Este processo <strong>não possui</strong> nenhum Recurso ou Contrarrazão <strong>enviados</strong> até o momento.</span>
    </div>
    <modal-inserir-recurso v-if="exibirPainelInserirRecurso"
                           :lotes-disponiveis="lotesDisponiveis"
                           :dadosLicitacao="licitacao"
                           @enviarRecurso="enviarRecurso"
                           @fecharModal="exibirPainelInserirRecurso = false"/>

    <modal-inserir-contrarrazao v-if="exibirPainelCriarContrarrazao"
                                :dadosLicitacao="licitacao"
                                :recurso="recursoCriandoContrarrazao"
                                @inserirContrarrazao="enviarContrarrazao"
                                @fecharModal="exibirPainelCriarContrarrazao = false"/>

    <modal-responder-recurso-contrarrazao v-if="exibirPainelResponderRecurso"
                              :dadosLicitacao="licitacao"
                              :tipoResposta="tipoRespondendo"
                              :dadosRecursoContrarrazao="recursoContrarrazaoRespondendo"
                              @responderRecurso="responderRecurso"
                              @responderContrarrazao="responderContrarrazao"
                              @fecharModal="exibirPainelResponderRecurso = false"/>

    <modal-visualizar-recurso-contrarrazao v-if="exibirPainelVisualizarRecurso"
                                           :dadosLicitacao="licitacao"
                                           :tipo="tipoVisualizando"
                                           :dadosRecurso="recursoContrarrazaoVisualizando"
                                           @fecharModal="exibirPainelVisualizarRecurso = false"/>
  </div>
</template>
<script>
import ModalInserirRecurso from "@/views/credenciamento/detalhe-credenciamento/orgao/recursocontrarrazao/modal/ModalInserirRecurso.vue";
import CredenciamentoRecursoContrarrazaoTabela from "@/views/credenciamento/detalhe-credenciamento/orgao/recursocontrarrazao/CredenciamentoRecursoContrarrazaoTabela.vue";
import ModalVisualizarRecurso from "@/views/credenciamento/detalhe-credenciamento/orgao/recursocontrarrazao/modal/ModalVisualizarRecursoContrarrazao.vue";
import ModalVisualizarRecursoContrarrazao
  from "@/views/credenciamento/detalhe-credenciamento/orgao/recursocontrarrazao/modal/ModalVisualizarRecursoContrarrazao.vue";
import {mapActions, mapState} from "vuex";
import ModalInserirContrarrazao
  from "@/views/credenciamento/detalhe-credenciamento/orgao/recursocontrarrazao/modal/ModalInserirContrarrazao.vue";
import ModalResponderRecursoContrarrazao
  from "@/views/credenciamento/detalhe-credenciamento/orgao/recursocontrarrazao/modal/ModalResponderRecursoContrarrazao.vue";
import {actionTypes, tipoRecursoContrarrazao} from "@/commons/constants";

export default {
  name: 'CredenciamentoRecursoContrarrazao',
  components: {
    ModalVisualizarRecursoContrarrazao,
    ModalResponderRecursoContrarrazao,ModalInserirContrarrazao,
    ModalVisualizarRecurso, CredenciamentoRecursoContrarrazaoTabela, ModalInserirRecurso
  },
  data(){
    return{
      tipoRecursoContrarrazao,
      colunasTabela: [
        {
          text: 'Licitante',
          align: 'left',
          sortable: false,
          width: '250px',
          class: 'primary--text'
        },
        {
          text: 'Tipo',
          align: 'left',
          sortable: false,
          width: '250px',
          class: 'primary--text'
        },
        {
          text: 'Envio',
          align: 'left',
          sortable: false,
          width: '150px',
          class: 'primary--text'
        },
        {
          text: 'Situação',
          sortable: false,
          align: 'left',
          class: 'primary--text'
        },
        {
          text: 'Ações',
          sortable: false,
          align: 'center',
          width: '120px',
          class: 'primary--text'
        }
      ],
      licitacaoId: null,
      exibirPainelInserirRecurso: false,
      exibirPainelVisualizarRecurso: false,
      exibirPainelCriarContrarrazao: false,
      exibirPainelResponderRecurso: false,
      recursoCriandoContrarrazao: null,
      recursoContrarrazaoVisualizando:null,
      recursoContrarrazaoRespondendo:null,
      tipoRespondendo:null,
      tipoVisualizando:null,
      lotesDisponiveis:[],
      recursos: [],
      contrarrazoes: [],
      prazoEncerrado: false
    }
  },
  computed:{
    ...mapState(['licitacao', 'lotesLicitacao']),
    ehFornecedor(){
      return this.$store.state.loki.user.type === 'EXTERNO'
    },
    possuiPermissaoRecurso(){
      return this.lotesDisponiveis && this.lotesDisponiveis.length > 0
    }
  },
  async mounted() {
    this.setLicitacaoId()
    this.buscarLicitacao(this.licitacaoId)
    await this.buscarRecursosContrarrazaoLicitacao()
    await this.buscarLotesDisponiveis()
  },
  methods:{
    ...mapActions([
        actionTypes.BUSCAR_LOTES_RECURSO_PERMITIDO,
        actionTypes.BUSCAR_LICITACAO,
        actionTypes.BUSCAR_RECURSOS_CONTRARRAZOES,
        actionTypes.INSERIR_RECURSO,
        actionTypes.INSERIR_CONTRARRAZAO,
        actionTypes.INSERIR_RESPOSTA_RECURSO,
        actionTypes.INSERIR_RESPOSTA_CONTRARRAZAO,
        actionTypes.INSERIR_RECURSO,
    ]),
    abrirModalVisualizar(tipo, id){
      if(tipo === tipoRecursoContrarrazao.RECURSO){
        this.recursoContrarrazaoVisualizando = this.recursos.find(recurso => recurso.id === id)
      }else{
        this.recursoContrarrazaoVisualizando = this.contrarrazoes.find(contrarrazao => contrarrazao.id === id)
      }
      this.tipoVisualizando = tipo
      this.exibirPainelVisualizarRecurso = true
    },
    abrirModalCriarContrarrazao(id){
      this.recursoCriandoContrarrazao = this.recursos.find(recurso => recurso.id === id)
      this.exibirPainelCriarContrarrazao = true
    },
    abrirModalCriarResposta(tipo, id){
      if(tipo === tipoRecursoContrarrazao.RECURSO){
        this.recursoContrarrazaoRespondendo = this.recursos.find(recurso => recurso.id === id)
      }else{
        this.recursoContrarrazaoRespondendo = this.contrarrazoes.find(contrarrazao => contrarrazao.id === id)
      }
      this.tipoRespondendo = tipo
      this.exibirPainelResponderRecurso = true
    },
    setLicitacaoId() {
      if(this.$route.params.id){
        this.licitacaoId = this.$route.params.id
      }
    },
    async buscarRecursosContrarrazaoLicitacao(ocultarLoading){
      if(!ocultarLoading) {
        this.habilitarLoadingGlobal()
        this.setMensagemLoading('Atualizando a listagem de recursos...')
      }
      const resposta = await this.buscarRecursosContrarrazoes(this.licitacaoId)
      if (resposta) {
        this.recursos = resposta.recursos
        this.contrarrazoes = resposta.contrarrazoes
      }
      this.desabilitarLoadingGlobal()
    },
    async buscarLotesDisponiveis(ocultarLoading) {
      if(!ocultarLoading) {
        this.habilitarLoadingGlobal()
        this.setMensagemLoading('Atualizando listagem de lotes...')
      }
      const {lotes, prazoEncerradoParaRecurso} = await this.buscarLotesRecursoPermitido(this.licitacaoId)
      this.desabilitarLoadingGlobal()
      this.lotesDisponiveis = lotes
      this.prazoEncerrado = prazoEncerradoParaRecurso
    },
    async enviarRecurso(dadosRecurso){
      this.habilitarLoadingGlobal()
      this.setMensagemLoading('Enviando Recurso...')
      await this.inserirRecurso({licitacaoId: this.licitacaoId, ...dadosRecurso})
      this.desabilitarLoadingGlobal()
      this.exibirPainelInserirRecurso = false
      this.mostrarNotificacaoSucesso('Recurso enviado com sucesso!')
      await this.buscarRecursosContrarrazaoLicitacao()
      await this.buscarLotesDisponiveis()
    },
    async enviarContrarrazao(dadosContrarrazao){
      this.habilitarLoadingGlobal()
      this.setMensagemLoading('Enviando Contrarrazão...')
      await this.inserirContrarrazao({licitacaoId: this.licitacaoId, ...dadosContrarrazao})
      this.exibirPainelCriarContrarrazao = false
      this.mostrarNotificacaoSucesso('Contrarrazão enviada com sucesso!')
      await this.buscarRecursosContrarrazaoLicitacao()
      this.desabilitarLoadingGlobal()
      this.fecharModal()
    },
    async responderRecurso(dadosResposta){
      this.habilitarLoadingGlobal()
      this.setMensagemLoading('Enviando Resposta...')
      await this.inserirRespostaRecurso(dadosResposta)
      this.exibirPainelResponderRecurso = false
      this.mostrarNotificacaoSucesso('Recurso respondido com sucesso!')
      this.desabilitarLoadingGlobal()
      await this.buscarRecursosContrarrazaoLicitacao()
    },
    async responderContrarrazao(dadosResposta){
      this.habilitarLoadingGlobal()
      this.setMensagemLoading('Enviando Resposta...')
      await this.inserirRespostaContrarrazao(dadosResposta)
      this.exibirPainelResponderRecurso = false
      this.mostrarNotificacaoSucesso('Contrarrazão respondida com sucesso!')
      this.desabilitarLoadingGlobal()
      await this.buscarRecursosContrarrazaoLicitacao()
    },
    async atualizarAutomatico(){
      this.desabilitarLoadingGlobal()
      await this.buscarRecursosContrarrazaoLicitacao(true)
      await this.buscarLotesDisponiveis(true)
    }
  },
  timers:{
    atualizarAutomatico:{
      time: 5000,
      repeat: true,
      autostart: true
    }
  }
}
</script>
<style lang="stylus">
.sem-conteudo
  font-size 1.2em
  display flex
  align-items center
  justify-content center
  border: 2px solid #ccc
  background-color: #eeeeee
  color: #7b7b7b
  height 200px
</style>